import { Component } from '@angular/core';

@Component({
  selector: 'app-assemble-taglist',
  imports: [],
  templateUrl: './assemble-taglist.component.html',
  styleUrl: './assemble-taglist.component.css'
})
export class AssembleTaglistComponent {

}
